
<div class="row">
  <div class="col-md-3 bg-white rounded shadow">
    <div class="pl-3 pr-5">
      <app-navbar [step]="8">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <app-breadcrumb [title]="'Grievance'"></app-breadcrumb>
    <section class="container">
      <div class="row">
        <div class="col-lg-12 mx-auto">
          <div class="card border-0 bg-white rounded-3 shadow mb-5">
            <div class="card-body p-0">
              <div class="py-1 px-3">
                <div class="row">
                  <div class="col-lg-3 ml-3">
                    <div class="form-group mb-3">
                      <label class="form-label fw-bold mb-2" for="refNo">
                        Search
                      </label>
                      <input [(ngModel)]="query.refNo" type="text" class="form-control " placeholder="Search" id="refNo">
                    </div>
                  </div>
                  <div class="col-lg-3 mr-3">
                    <div class="form-group mb-3">
                      <label class="form-label fw-bold mb-2" for="isActive">
                        Query Type
                      </label>
                      <select [(ngModel)]="query.isActive" class="form-select " for="isActive" name="isActive">
                        <option value="" selected>--SELECT--</option>
                        <option *ngFor="let item of returTypes" value="{{ item.value }}">{{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-2">
                    <div class="form-group mb-0 d-flex justify-content-end mt-4">
                      <button class="btn btn-primary rounded-3 border-2 m-1 px-2" (click)="filter()">Search</button>
                      <button type="button" class="btn  btn-outline-dark rounded-3 border-2 m-1 px-2"
                        (click)="resetClick()">Reset</button>
                    </div>
                  </div>
                </div>
                <div class="row">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card border-0 bg-white rounded-3 shadow mb-5">
            <div class="card-body">
              <div class="d-flex justify-content-end">
                <button class="btn btn-sm btn-danger mb-3" (click)="onAddGrivance()">Create
                  New Grievance</button>
              </div>
              <div *ngIf="queryResult.items" class="table">
                <table class="table align-items-center">
                  <colgroup>
                    <col style="width: 8%">
                    <col style="width: 12%">
                    <col style="width: 8%">
                    <col style="width: 15%">
                    <col style="width: 55%">
                    <col style="width: 7%">
                    <col style="width: 5%">
                  </colgroup>
                  <thead class="table-light">
                    <tr>
                      <th class="" *ngFor="let c of columns">
                        <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ c.title }}
                            <div class="ml-2">
                              <i-bs *ngIf="query.sort === c.key"
                                [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'"></i-bs>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="!c.isSortable">
                          {{ c.title }}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of queryResult.items;let indexOfelement=index;">
                      <td>{{ indexOfelement+1}}</td>
                      <td>{{ item.createdAt | date }}</td>
                      <td>{{ item.refNo }}</td>
                      <td>{{ item.grievanceTypes?.name }}</td>
                      <td>{{ item.comment }}</td>
                      <td>
                        <span *ngIf="item.statusId==1" class="badge bg-info">Pending</span>
                        <!-- <span *ngIf="item.statusId==3" class="badge bg-warning">Recall</span> -->
                        <span *ngIf="item.statusId==2" class="badge bg-danger"
                          style="background: linear-gradient(45deg, #FFB64D, #ffcb80)!important;">Closed</span>
                      </td>
                      <td>
                        <div ngbDropdown class="d-inline-block" style="background-color: #f3e8e8;">
                          <button class="btn btn-outline-danger" ngbDropdownToggle>Action</button>
                          <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="background-color: #f3e8e8;">
                            <button ngbDropdownItem (click)="onViewGrievance(item.id, 1)">View Grievance</button>
                            <!-- <ng-container *ngIf="item.statusId==2">
                              <button ngbDropdownItem (click)="onRecallGrievance(item.id, 2)">Resubmit Grievance</button>
                            </ng-container> -->
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <em>
                <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
                </pagination>
              </em>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>





<!-- <ng-template #createSubmissionModal let-modal>
    <div class="modal-header text-white bg-them-danger-1 rounded p-2">
      <div class="d-flex justify-content-between align-items-center w-100 ">
        <h4 class="h5 fw-bold">
          New Request
        </h4>
        <button type="button" class="btn btn-link shadow-none px-0 text-white text-bold" (click)="close()">
          <i-bs name="x"></i-bs>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <div class="row px-lg-4">
        <div class="col-lg-12 p-3">
          <form [formGroup]="serviceRequestsForm" (ngSubmit)="submit()">
            <input type="hidden" formControlName="id">
            <input type="hidden" formControlName="userMasterId">
            <div class="row px-lg-4">
              <div class="col-lg-6">
                <div class="form-group mb-3">
                  <label class="text-muted form-label fw-bold">
                    RequestTypes
                    <small class="text-danger">*</small>
                  </label>
                  <select (change)="loadFillingPeriods($event.target.value)" class="form-select ">
                    <option value="" selected>--Select--</option>
                    <option *ngFor="let item of returTypes" value="{{ item.id }}">{{ item.name }}
                    </option>
                  </select>
                  <error-field controlName="returTypesId" errorKey="required">Select Retur Types</error-field>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-3">
                  <label class="text-muted form-label fw-bold" for="media">
                    Field
                    <small class="text-danger">*</small>
                  </label>
                  <select MyInput formControlName="serviceFieldId" class="form-select ">
                    <option value="" selected>--Select--</option>
                    <option *ngFor="let item of fillingPeriods" value="{{ item.id }}">{{ item.name }}
                    </option>
                  </select>
                  <error-field controlName="serviceFieldId" errorKey="required">Select Filling Period</error-field>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-5">
              <button class="btn btn-theme-alternate-1 rounded-3 me-2 px-5"
                [disabled]="!serviceRequestsForm.valid || loading" type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
              <button class="btn btn-outline-dark rounded-3 border-2 px-5" type="button" (click)="close()">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>
   -->
